import style from "./Comments.module.css"

export default function CommentsTitle(props) {
  const { title } = props;
  return (
    <div className="text-center">
      <p className={style.commentTitle}>
        <span>
          {title}
        </span>
      </p>
    </div>
  )
}